import {LOCATION_CHANGE} from 'react-router-redux';
import * as THREE from 'three';

import {ANIMATION_FRAME} from '../actions';
import {PLANET_ERROR, PLANET_REQUEST, PLANET_SUCCESS, UPDATE_ELEVATION, UPDATE_RADIUS} from '../actions/planet';

const initialState = {
    loading: false,
    elevation: 8,
    position: new THREE.Vector3(0, 0, 0),
    radius: 48,
    rotation: new THREE.Euler(0, 0, 0),
    seed: 0,
    noise: [],
    normals: [],
    points: [],
    randoms: [],
    regions: [],
    vertices: [],
    error: null
};

export default(state = initialState, action) => {
    switch (action.type) {

        case LOCATION_CHANGE:
            return initialState;

        case PLANET_ERROR:
            console.log(action);
            return {
                ...initialState,
                error: action.payload
            };

        case ANIMATION_FRAME:
            return {
                ...state,
                rotation: new THREE.Euler(0, state.rotation.y + action.delta / 8, 0)
            };

        case PLANET_SUCCESS:
            console.log(action);
            return {
                ...state,
                ...action.payload,
                loading: false
            };

        case PLANET_REQUEST:
            console.log(action);
            return {
                ...state,
                loading: true
            }

        case UPDATE_ELEVATION:
            return {
                ...state,
                elevation: parseInt(action.elevation, 10)
            };

        case UPDATE_RADIUS:
            const radius = parseInt(action.radius, 10);
            return {
                ...state,
                radius
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/apps/scene-planet/reducers/planet.js